module.exports = __webpack_public_path__ + "static/fullLight-b468d7ca8770e26f6840957a78f1ca95.png";